import { Box } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'
import type { FC } from 'react'

interface Props {
  color?: string
  size?: 'sm' | 'md' | 'lg'
}

const LoadingThrobber: FC<Props> = ({ color = 'bg.inverted', size = 'md' }) => {
  let width = '1.7em'
  let height = '1.7em'

  if (size === 'sm') {
    width = '1.2em'
    height = '1.2em'
  } else if (size === 'lg') {
    width = '2.2em'
    height = '2.2em'
  }

  const bblFadInOut = keyframes`
    0%, 80%, 100% { box-shadow: 0 ${width} 0 -0.9em }
    40% { box-shadow: 0 ${width} 0 0 }
  `

  const sharedStyles = {
    borderRadius: '50%',
    width: width,
    height: height,
    animationFillMode: 'both',
    animation: `${bblFadInOut} 1.8s infinite ease-in-out`
  }

  return (
    <Box
      color={color}
      display="inline-block"
      width={width}
      height={height}
      position="relative"
      css={{
        fontSize: '7px',
        transform: 'translateZ(0)',
        animationDelay: '0.16s',
        ...sharedStyles,
        '&:before, &:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          ...sharedStyles
        },
        '&:before': {
          left: '-2.7em',
          animationDelay: '-0.32s'
        },
        '&:after': {
          left: '2.7em'
        }
      }}
    />
  )
}

export default LoadingThrobber
